import React, { ReactNode } from 'react';
import cx from 'classnames';
import { PortholeImage } from './PortholeImage';

import './InfoTileV2.css';

type InfoTileProps = {
  className?: string;
  heading?: string | ReactNode;
  dek?: string | ReactNode;
  imgAlt?: string;
  imgSrc?: string;
  hideDek?: boolean;
  ctaLink?: string | ReactNode;
  ctaCopy?: string;
  ctaTarget?: string;
  ctaRel?: string;
  handleCtaLinkClick?: () => void;
  displayAsColumn?: boolean;
  moreSpace?: boolean;
  href?: string;
};

export const InfoTileV2 = ({
  className,
  heading,
  dek,
  imgAlt,
  imgSrc,
  ctaLink,
  ctaCopy = 'Read more',
  ctaTarget,
  ctaRel,
  hideDek,
  handleCtaLinkClick,
  displayAsColumn,
  moreSpace,
  href,
}: InfoTileProps): JSX.Element => {
  const classes = cx(
    'zola-ui',
    'info-tile',
    { 'info-tile--column': displayAsColumn },
    { 'info-tile--moreSpace': moreSpace },
    { 'info-tile--pointer': href },
    className
  );

  const renderCtaLink = () => {
    if (!ctaLink) return null;
    if (typeof ctaLink === 'string')
      return (
        <a
          className="info-tile__cta info-tile__cta--link"
          href={ctaLink}
          onClick={handleCtaLinkClick}
          target={ctaTarget}
          rel={ctaRel}
        >
          {ctaCopy}
        </a>
      );
    return <div className="info-tile__cta">{ctaLink}</div>;
  };

  const handleTileOnClick = () => {
    if (href) window.location.href = href;
  };

  return (
    <div className={classes} onClick={handleTileOnClick}>
      {imgSrc && (
        <PortholeImage
          className="info-tile__image info-tile__image--v2"
          src={imgSrc}
          alt={imgAlt}
        />
      )}
      <div className="info-tile__content">
        {heading && <h3 className="info-tile__heading">{heading}</h3>}
        {dek && !hideDek && <div className="info-tile__dek">{dek}</div>}
        {renderCtaLink()}
      </div>
    </div>
  );
};

export default InfoTileV2;
